export default "__VITE_ASSET__DBoJ07MB__"